import { render, staticRenderFns } from "./SegmentTimePairTable.vue?vue&type=template&id=0ec848de&scoped=true&"
import script from "./SegmentTimePairTable.vue?vue&type=script&lang=js&"
export * from "./SegmentTimePairTable.vue?vue&type=script&lang=js&"
import style0 from "./SegmentTimePairTable.vue?vue&type=style&index=0&id=0ec848de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec848de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBadge,VDataTable})
